import React, { useState, useEffect } from "react";
import axios from "axios";
import { TrendingUp } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const MostReadBlog = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios.get(`${API}/blog/most-read?limit=3`).then(r => setPosts(r.data || [])).catch(() => {});
  }, []);

  if (!posts.length) return null;

  const openPost = (post) => {
    document.getElementById("blog")?.scrollIntoView({ behavior: "smooth" });
    // Notify BlogSection to open this post
    window.dispatchEvent(new CustomEvent("open-blog-post", { detail: { id: post.id } }));
  };

  return (
    <section className="py-16 bg-amber-50/40 border-y border-amber-100" data-testid="most-read-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3 mb-8">
          <TrendingUp className="text-emerald-700" size={28} />
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-gray-900">Most Read This Week</h2>
        </div>
        <p className="text-gray-600 mb-8 max-w-2xl">
          The articles families are reading right now.
        </p>
        <div className="grid md:grid-cols-3 gap-6">
          {posts.map((post, i) => (
            <button
              key={post.id}
              onClick={() => openPost(post)}
              className="text-left bg-white rounded-2xl border border-amber-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 overflow-hidden group"
              data-testid={`most-read-card-${i}`}
            >
              {post.image_ids && post.image_ids.length > 0 ? (
                <div className="aspect-video w-full overflow-hidden bg-gray-100">
                  <img
                    src={`${API}/images/${post.image_ids[0]}`}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform"
                  />
                </div>
              ) : (
                <div className="aspect-video w-full bg-gradient-to-br from-emerald-700 to-emerald-900 flex items-center justify-center">
                  <span className="font-display text-3xl text-amber-300">#{i + 1}</span>
                </div>
              )}
              <div className="p-5">
                <div className="flex items-center justify-between text-xs text-gray-500 mb-2">
                  <span className="bg-emerald-50 text-emerald-700 px-2 py-0.5 rounded-full font-medium">{post.category}</span>
                  {post.views > 0 && (
                    <span className="font-medium">{post.views} {post.views === 1 ? "view" : "views"}</span>
                  )}
                </div>
                <h3 className="font-display font-bold text-gray-900 text-lg leading-snug line-clamp-2 group-hover:text-emerald-700 transition-colors">
                  {post.title}
                </h3>
                <p className="text-gray-600 text-sm mt-2 line-clamp-3">{post.content.substring(0, 140)}…</p>
                <span className="inline-block mt-3 text-emerald-700 font-medium text-sm group-hover:underline">Read more →</span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MostReadBlog;
